import { createNode } from '@glueapp/graph-types';
import { DataValue } from '@glueapp/graph-types';

export const SortListOfNumbers = createNode({
    id: 'Sort List of Numbers',
    name: 'Sort List of Numbers',
    description: 'Sorts a list of numbers, Example: [8, 1, 5, 3, -4] becomes [-4, 1, 3, 5, 8]',
    aiDescription:
        'Sorts a list of numbers numerically. Connect "List" (array of number) and set "Order" to "Ascending" or "Descending". Output: "Sorted List".',
    category: 'List',
    color: '#778ed5',
    integration: undefined,
    inPorts: {
        List: {
            kind: 'array',
            subType: {
                kind: 'number',
            },
        },
        Order: {
            kind: 'union',
            subTypes: [
                { kind: 'stringLiteral', stringLiteral: 'Ascending' },
                { kind: 'stringLiteral', stringLiteral: 'Descending' },
            ],
        },
    },
    outPorts: {
        'Sorted List': {
            kind: 'array',
            subType: {
                kind: 'number',
            },
        },
    },
    execute: function (input) {
        const inputArray = input.inPorts.List as number[];
        const order = input.inPorts.Order;
        let sortedArray;
        switch (order) {
            case 'Ascending':
                sortedArray = Array.from(inputArray).sort((a, b) => a - b);
                break;
            case 'Descending':
                sortedArray = Array.from(inputArray).sort((a, b) => b - a);
                break;
        }
        return { output: { 'Sorted List': sortedArray as DataValue[] } };
    },
});
